export default __webpack_public_path__ + "static/media/1452.810ec6fe.png";